window.addEventListener('DOMContentLoaded', () => {


  // DOM 요소 캐싱 및 존재 여부 확인
  const $homeRequest = document.getElementById('homeRequest');
  if (!$homeRequest) return;

  const $slogan = $homeRequest.querySelector('.__slogan');
  const desc = $homeRequest.querySelector('.__desc');
  const $typingArea = $homeRequest.querySelector('.__typing strong');
  const $bgImg = $homeRequest.querySelector('.__bg img');
  const $motionEl = $homeRequest.querySelector('.__motion');
  const $line1 = $homeRequest.querySelector('.__line1');
  const $line2 = $homeRequest.querySelector('.__line2');
  const $rect = $homeRequest.querySelector('.__rect');
  const $ctaBtn = $homeRequest.querySelector('.cta-btns .btn');
  const $overlay = $homeRequest.querySelector('.__bg .__overlay');



  // 타이핑 콘텐츠 저장
  const typingContent = $typingArea.textContent || 'your journey';
  let typingInterval = null;
  let isTypingActive = false;

  // 접근성을 위한 간소화된 초기화
  if (window.prefersReducedMotion) {
    // 애니메이션 비활성화 시 즉시 표시
    $motionEl.style.clipPath = 'none';
    $motionEl.style.webkitClipPath = 'none';
    if ($overlay) $overlay.style.opacity = '0';
    if ($ctaBtn) {
      $ctaBtn.style.opacity = '1';
      $ctaBtn.style.transform = 'translateY(0)';
    }
    return;
  }

  // 성능 최적화된 파라미터 계산
  const calculateParams = (() => {
    let cachedParams = null;
    let lastResize = 0;

    return () => {
      const now = Date.now();
      if (cachedParams && (now - lastResize) < 100) {
        return cachedParams;
      }

      try {
        const homeRequestRect = $homeRequest.getBoundingClientRect();
        const sloganRect = $slogan.getBoundingClientRect();

        cachedParams = {
          ww: window.innerWidth,
          wh: window.innerHeight,
          height: $motionEl.clientHeight,
          cy: sloganRect.y - homeRequestRect.y + (sloganRect.height / 2),
          lh: sloganRect.height,
          DIFF: 30
        };

        lastResize = now;
        return cachedParams;
      } catch (error) {
        console.warn('Parameter calculation failed:', error);
        return {
          ww: window.innerWidth,
          wh: window.innerHeight,
          height: 600,
          cy: 300,
          lh: 60,
          DIFF: 30
        };
      }
    };
  })();

  let params = calculateParams();

  // 리사이즈 핸들러 최적화
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      params = calculateParams();
      try {
        onComplete(); // 애니메이션 완료 상태로 설정
      } catch (error) {
        console.warn('Resize handling failed:', error);
      }
    }, 150);
  };

  window.addEventListener('resize', handleResize, { passive: true });

  // 클론 생성 (에러 핸들링 포함)
  try {
    const requestClone = desc.cloneNode(true);
    requestClone.classList.add('--clone');
    $homeRequest.prepend(requestClone);
  } catch (error) {
    console.warn('Clone creation failed:', error);
  }

  // 애니메이션 완료 함수
  function onComplete() {
    try {
      $motionEl.style.clipPath = 'none';
      $motionEl.style.webkitClipPath = 'none';
    } catch (error) {
      console.warn('Animation completion failed:', error);
    }
  }

  // 애니메이션 시작 함수
  function onStart() {
    try {
      gsap.set($line1, {
        attr: {
          d: `M 0 ${params.cy - params.lh} L 0 ${params.cy - params.lh} L ${-params.DIFF} ${params.cy} L 0 ${params.cy} Z`
        }
      });
      gsap.set($line2, {
        attr: {
          d: `M ${params.ww} ${params.cy} L ${params.ww + params.DIFF} ${params.cy} L ${params.ww} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
        }
      });
      gsap.set($rect, {
        attr: {
          d: `M 0 ${params.cy} L ${params.ww} ${params.cy} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
        }
      });
    } catch (error) {
      console.warn('Animation start failed:', error);
    }
  }

  // 타이핑 애니메이션 함수
  function startTyping() {
    if (isTypingActive) return;
    isTypingActive = true;

    try {
      $typingArea.textContent = '\xa0';
      let i = 0;

      typingInterval = setInterval(() => {
        if (i < typingContent.length && isTypingActive) {
          const char = typingContent.charAt(i);
          $typingArea.textContent += (char === ' ') ? '\xa0' : char;
          i++;
        } else {
          clearInterval(typingInterval);
          isTypingActive = false;
        }
      }, 80);
    } catch (error) {
      console.warn('Typing animation failed:', error);
      $typingArea.textContent = typingContent;
      isTypingActive = false;
    }
  }

  // 타이핑 정지 함수
  function stopTyping() {
    isTypingActive = false;
    clearInterval(typingInterval);
  }

  // 초기 설정
  try {
    $typingArea.textContent = '';
    onStart();
  } catch (error) {
    console.warn('Initial setup failed:', error);
  }

  // 메인 애니메이션 타임라인
  let motion = null;

  try {
    motion = gsap.timeline({
      paused: true,
      onStart: onStart,
      onComplete: onComplete
    })
        .to($overlay, {
          duration: 2,
          opacity: 0
        }, 0.5)
        .fromTo($bgImg,
            { scale: 3 },
            {
              scale: 1,
              duration: 3.5,
              ease: 'power2.out'
            }, 0)
        .to($line1, {
          attr: {
            d: () => `M 0 ${params.cy - params.lh} L${params.ww + params.DIFF} ${params.cy - params.lh} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
          },
          duration: 1,
          ease: 'circ.inOut'
        }, 0)
        .to($line2, {
          attr: {
            d: () => `M ${params.ww} ${params.cy} L${0} ${params.cy} L ${-params.DIFF} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
          },
          duration: 1,
          ease: 'circ.inOut'
        }, 0)
        .to($rect, {
          attr: {
            d: () => `M 0 0 L ${params.ww} 0 L ${params.ww} ${params.height} L 0 ${params.height} Z`
          },
          duration: 1.6,
          ease: 'power2.out'
        }, 0.8)
        .fromTo($ctaBtn,
            { opacity: 0, y: 50 },
            {
              opacity: 1,
              y: 0,
              duration: 1.2,
              ease: 'power2.out'
            }, 1.6)
        .fromTo($typingArea,
            { width: 0 },
            {
              onStart: startTyping,
              width: 'auto',
              duration: 0.2,
              ease: 'power2.out'
            }, 1);

    motion.timeScale(1.4);

  } catch (error) {
    console.warn('Timeline creation failed:', error);
  }

  // ScrollTrigger 설정
  try {
    // 메인 애니메이션 트리거
    ScrollTrigger.create({
      trigger: $homeRequest,
      start: 'top 80%',
      end: 'top top',
      once: true,
      onEnter: () => {
        if (motion) {
          motion.play();
        }
        // 리사이즈 시 애니메이션 완료 상태로 설정
        const resizeHandler = () => onComplete();
        window.addEventListener('resize', resizeHandler, { once: true, passive: true });
      }
    });

    // 패럴랙스 스크롤 트리거
    ScrollTrigger.create({
      trigger: $homeRequest.querySelector('.__bg'),
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: (self) => {
        try {
          const progress = self.progress;
          gsap.set($bgImg, {
            objectPosition: `50% ${100 - (progress * 100)}%`
          });
        } catch (error) {
          console.warn('Parallax update failed:', error);
        }
      }
    });

  } catch (error) {
    console.warn('ScrollTrigger setup failed:', error);
  }

  // 페이지 가시성 변경 시 타이핑 제어
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && isTypingActive) {
      stopTyping();
    }
  });

});